// required snippet stories-api-url

(function () {
    let data_rows_params = {
        'limit': 1,
        'page': 1
    }
    function getStories(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: STORY_API_URL+"/stories",
                dataType: "json",
                data: params
            })
                .then(function (resp) {
                    if (resp.length !== 0) {
                        resolve(resp)
                    } else {
                        reject()
                    }
                })
                .catch(function () {

                    reject()
                })


        })
    }


        getStories(data_rows_params).then(function (res){
            $('.js-stories-count').map(function (){
                $(this).text(res.totalCount)
            })
        })


}());
